import {
  FormStageStage,
  TFormState,
} from '@/ui/components/createPurchaseOrderSidebar/CreatePurchaseOrderSidebar';
import { PurchaseOrderDeliveryAddressControl } from '@/ui/components/purchaseOrderDeliveryAddressControl/PurchaseOrderDeliveryAddressControl';
import PurchaseOrderDetailFields from '@/ui/components/purchaseOrderDetailFields/PurchaseOrderDetailFields';
import { Button } from '@payaca/ambrosia';

import { clstx } from '@payaca/utilities/cvaMerge';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export interface IProps {
  formStage: FormStageStage;
  projectId: number;
  hideList?: boolean;
  isSaving: boolean;
}

const IndirectPurchaseOrderDetails: FC<IProps> = (props) => {
  const { formStage, projectId, hideList = false, isSaving } = props;

  const formMethods = useFormContext<TFormState>();

  const selectedSupplierId = formMethods.watch('supplierId');

  return (
    <div className="bg-gray-50 p-3.5 border-l">
      <div
        className={clstx('flex flex-col gap-4 h-full', hideList && 'hidden')}
      >
        <h4>Order details</h4>

        <PurchaseOrderDetailFields
          renderDueAtInput={
            formStage === 'INDIRECT_PURCHASE_ORDER_DETAILS' || !hideList
          }
          dueAtInvalid={'dueAt' in formMethods.formState.errors}
          deliverTo={
            <Controller
              name="deliveryInfo"
              control={formMethods.control}
              render={({ field: { onChange, value } }) => {
                return (
                  <PurchaseOrderDeliveryAddressControl
                    supplierId={selectedSupplierId}
                    projectId={projectId}
                    onChange={onChange}
                    value={value}
                  />
                );
              }}
            />
          }
        />

        <Button
          className="mt-auto"
          type="submit"
          isProcessing={isSaving}
          disabled={isSaving}
        >
          Create order
        </Button>
      </div>
    </div>
  );
};

export default IndirectPurchaseOrderDetails;
